import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Zoom, styled } from "@mui/material";

const UnifiedDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "40px",
    padding: theme.spacing(3),
    boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
    border: "1px solid rgba(255,255,255,0.3)",
  },
}));

const EditorMessageDialog = ({
  open,
  onClose,
  title,
  message,
  detail,
  confirmText = "OK",
  accentColor = "#b30047",
}) => (
  <UnifiedDialog open={open} onClose={onClose} fullWidth maxWidth="sm" slots={{ transition: Zoom }}>
    <DialogTitle sx={{ color: accentColor, fontWeight: 800, textAlign: "center", fontSize: "1.4rem", pb: 1 }}>
      {title}
    </DialogTitle>
    <DialogContent>
      <Typography variant="body1" sx={{ textAlign: "center", color: "#4a5568" }}>
        {message}
      </Typography>
      {detail ? (
        <Typography variant="body2" sx={{ textAlign: "center", color: "#718096", mt: 1.5 }}>
          {detail}
        </Typography>
      ) : null}
    </DialogContent>
    <DialogActions sx={{ p: 3, pt: 1, justifyContent: "center" }}>
      <Button
        variant="contained"
        onClick={onClose}
        sx={{
          backgroundColor: accentColor,
          px: 5,
          py: 1.2,
          borderRadius: 4,
          textTransform: "none",
          fontWeight: "bold",
          boxShadow: `0 8px 20px ${accentColor}40`,
          "&:hover": { backgroundColor: accentColor, filter: "brightness(1.1)" },
        }}
      >
        {confirmText}
      </Button>
    </DialogActions>
  </UnifiedDialog>
);

EditorMessageDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  detail: PropTypes.string,
  confirmText: PropTypes.string,
  accentColor: PropTypes.string,
};

export default EditorMessageDialog;
 